import type { ReactNode } from 'react';
import {
  SaveShortcutBoundary,
  type SaveShortcutStrategy,
} from '@src/shared/ui/SaveShortcutScope';
import Layout from './Layout';
import PageLayoutProvider from './provider';

type PageProps = {
  children: ReactNode;
  fillHeight?: boolean;
  shortcutStrategy?: SaveShortcutStrategy;
};

export default function Page({
  children,
  fillHeight = false,
  shortcutStrategy = 'all',
}: PageProps) {

  return (
    <PageLayoutProvider>
      <SaveShortcutBoundary priority="page" strategy={shortcutStrategy}>
        <Layout fillHeight={fillHeight}>{children}</Layout>
      </SaveShortcutBoundary>
    </PageLayoutProvider>
  );
}
